import BaseApi from './base'

class MostFrequentQuestion extends BaseApi {
  getMostFrequentQuestions = (query) =>
    this.client.get(`admin/most-frequent-question?${query}`)

  getMostFrequentQuestion = (id) =>
    this.client.get(`admin/most-frequent-question/${id}`)

  addMostFrequentQuestion = (data) =>
    this.client.post('admin/most-frequent-question', data)

  updateMostFrequentQuestion = ({ questionId, payload }) =>
    this.client.patch(`admin/most-frequent-question/${questionId}`, payload)

  updateMostFrequentQuestionStatus = ({ questionId, payload }) =>
    this.client.patch(
      `admin/most-frequent-question/${questionId}/status`,
      payload
    )

  deleteMostFrequentQuestion = (id) =>
    this.client.delete(`admin/most-frequent-question/${id}`)

  upsertMostFrequentQuestionContent = ({ questionId, languageId, payload }) =>
    this.client.post(
      `admin/most-frequent-question/${questionId}/content/${languageId}`,
      payload
    )

  getMostFrequentQuestionContent = ({ questionId, languageId }) =>
    this.client.get(
      `admin/most-frequent-question/${questionId}/content/${languageId}`
    )
}

export default new MostFrequentQuestion()
